/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
import Lenis from "@studio-freight/lenis";
const lenis = new Lenis({
  smoothWheel: true,
  smoothTouch: false,
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

function handleAnchorClick(e) {
  e.preventDefault(); // Prevent default anchor behavior

  const targetId = this.getAttribute("href"); // Get the href attribute value
  const targetElement = document.querySelector(targetId); // Find the target element

  if (targetElement) {
    lenis.scrollTo(targetElement); // Use Lenis to scroll to the target element
  }
}

// Get all anchor links on the page that link to an ID on the same page
const anchorLinks = document.querySelectorAll('a[href^="#"]');

// Add the click event listener to each anchor link
anchorLinks.forEach((link) => {
  link.addEventListener("click", handleAnchorClick);
});

const mainMenu = document.querySelector(".menu-wrapper");
const body = document.querySelector("body");

var mobileNavWrapper = document.querySelector("#mobile-nav-wrapper");
var navWChildren = document.querySelectorAll(
  "#mobile-menu-inner > .menu-item-has-children > a"
);
var navWChildrenWChildren = document.querySelectorAll(
  "#mobile-menu-inner .menu-item-has-children > ul > div > .menu-item-has-children > a"
);
var subBacks = document.querySelectorAll(".sub-back");
var subOpen = false;

document.getElementById("menu-toggle").addEventListener("click", function () {
  if (body.classList.contains("menu-open")) {
    html.classList.remove("no-scroll");
    lenis.start();

    body.classList.remove("menu-animate");
    body.classList.remove("menu-toggled");
    setTimeout(function () {
      body.classList.remove("menu-open");
    }, 500);
  } else {
    lenis.stop();
    console.log("hey");
    setTimeout(function () {
      body.classList.add("menu-open");
      body.classList.add("menu-toggled");
      html.classList.add("no-scroll");
      body.classList.add("menu-animate");
    }, 150);
  }
});

navWChildren.forEach((i) => {
  i.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the i from following its href
    // console.log("sub-open");
    if (!this.parentElement.classList.contains("sub-active")) {
      // Check if the i doesn't have the new class
      this.parentElement.classList.add("sub-active"); // Add the new class to the i
      mobileNavWrapper.classList.add("sub-open");
      var subOpen = false;
    }
  });
});
navWChildrenWChildren.forEach((i) => {
  i.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the i from following its href
    // console.log("sub-sub-open");
    if (!this.parentElement.classList.contains("sub-active")) {
      // Check if the i doesn't have the new class
      this.parentElement.classList.add("sub-active"); // Add the new class to the i
      mobileNavWrapper.classList.remove("sub-open");
      mobileNavWrapper.classList.add("sub-sub-open");
    }
  });
});

subBacks.forEach((i) => {
  i.addEventListener("click", (e) => {
    if (mobileNavWrapper.classList.contains("sub-open")) {
      mobileNavWrapper.classList.remove("sub-open");
    } else {
      mobileNavWrapper.classList.remove("sub-sub-open");
      mobileNavWrapper.classList.add("sub-open");
    }

    setTimeout(function () {
      i.parentElement.parentElement.parentElement.classList.remove(
        "sub-active"
      );
    }, 500);
  });
});

let animateFocusTimer;
let removeAnimateFocusTimer;
let removeFocusTimer;
let bodyTimer;

const menuItems = document.querySelectorAll(
  "#main-menu > .menu-item-has-children"
);

menuItems.forEach(function (item) {
  item.addEventListener("mouseenter", function () {
    clearTimeout(animateFocusTimer);
    clearTimeout(removeAnimateFocusTimer);
    clearTimeout(removeFocusTimer);
    clearTimeout(bodyTimer);

    // Delay the removal of classes from siblings to prevent flickering
    menuItems.forEach((sibling) => {
      if (sibling !== item) {
        setTimeout(() => {
          sibling.classList.remove("focused");
          sibling.classList.remove("animate-focused");
        }, 15); // Adjust the delay as needed
      }
    });

    this.classList.add("focused");
    document.body.classList.add("dropdown-open");
    animateFocusTimer = setTimeout(() => {
      this.classList.add("animate-focused");
      document.body.classList.add("dropdown-animate");
    }, 15);
  });

  item.addEventListener("mouseleave", function () {
    removeAnimateFocusTimer = setTimeout(() => {
      this.classList.remove("animate-focused");
      document.body.classList.remove("dropdown-animate");
    }, 0);

    removeFocusTimer = setTimeout(() => {
      this.classList.remove("focused");
    }, 250);

    bodyTimer = setTimeout(() => {
      const hovegreenItems = document.querySelectorAll(
        "#primary-nav > .menu-item-has-children:hover"
      );
      if (!hovegreenItems.length) {
        document.body.classList.remove("dropdown-open");
      }
    }, 250);
  });
  var anchor = item.querySelector("a");
  if (anchor) {
    // Add a click event listener to the anchor
    anchor.addEventListener("click", function (event) {
      // Check if the html element has the 'on-dev' class
      if (document.documentElement.classList.contains("on-dev")) {
        // Prevent the default link behavior and stop event propagation
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }
});
